import React from "react";

import { BreadcrumbContainer } from "./BreadcrumbContainer";
import { HeaderSectionV2Props } from "./ProductHeaderSection";
import { ProductHeaderV2 } from "./ProductHeaderV2";

export const HeaderSectionContent = (props: HeaderSectionV2Props) => {
    const {
        title,
        minPrice,
        cancellationPolicy,
        guidePriceType,
        availability,
        breadcrumbs,
        guidePricePricingData,
        productRatingComponent,
    } = props;
    const hasFreeCancellation = cancellationPolicy?.hasFreeCancellation ?? false;

    return (
        <>
            {breadcrumbs && <BreadcrumbContainer>{breadcrumbs}</BreadcrumbContainer>}
            <ProductHeaderV2
                title={title}
                minPrice={minPrice}
                hasFreeCancellation={hasFreeCancellation}
                guidePriceType={guidePriceType}
                availability={availability}
                guidePricePricingData={guidePricePricingData}
                productRatingComponent={productRatingComponent}
            />
        </>
    );
};
